import Masonry from 'masonry-layout/dist/masonry.pkgd.min';
$(document).ready(function() {
	const grid = $('.blog-grid');
	if (grid.length) {
		new Masonry(grid[0], {
			itemSelector: '.grid-item'
		});
	}
});
